import { Link } from 'react-router-dom'
import invader from '../assets/invader.svg'
import classes from './Error.module.css'

const Error = () => {
  return (
    <div className={classes.container}>
      <div className={classes.innerContainer}>
      <img className={classes.image} src={invader} alt="Space invader" />
        <h1 className={classes.title}>404</h1>
        <h2 className={classes.subTitle1}>Ooops...</h2>
        <h3 className={classes.subTitle2}>Page not found</h3>
        <div>
          Let's go <Link className={classes.backHome} to="/">home</Link> and try from there
        </div>
      </div>
    </div>
  )
}

export default Error
